import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter'
})

export class FilterPipe implements PipeTransform {
    transform(items: any[], searchText: string | string[], field?: string, multiValue?: string, fullIfSearchTextEmpty?: boolean, searchPartial?: boolean): any[] {
        if (fullIfSearchTextEmpty == undefined) {
            fullIfSearchTextEmpty = true;
        }
        
        if (searchPartial == undefined) {
            searchPartial = true;
        }
        
        if (!items) return [];

        if ((!searchText || searchText.length == 0) && fullIfSearchTextEmpty) return items;

        let searchTextList: string[] = (typeof searchText == 'string') ? (multiValue != undefined ? searchText.split(multiValue) : [searchText]) : searchText;

        for (let i in searchTextList) {
            searchTextList[i] = searchTextList[i].toLowerCase();
        }

        return items.filter(it => {
            if (field != undefined && field != '') {
                let hasOne: boolean = false;

                for (let curSearch of searchTextList) {
                    if (typeof it[field] == 'string') {
                        hasOne = searchPartial?it[field].toLowerCase().includes(curSearch):it[field].toLowerCase() == curSearch;
                    } else {
                        for (let curElem of it[field]) {
                            hasOne = searchPartial?curElem.toLowerCase().includes(curSearch):curElem.toLowerCase() == curSearch;
                            if (hasOne) {
                                break;
                            }
                        }
                    }

                    if (hasOne) {
                        break;
                    }
                }

                return hasOne;
            } else {
                let hasOne: boolean = false;

                for (let curSearch of searchTextList) {
                    if (typeof it == 'string') {
                        hasOne = it.toLowerCase().includes(curSearch);
                    } else {
                        for (let curElem of it) {
                            hasOne = curElem.toLowerCase().includes(curSearch);
                            if (hasOne) {
                                break;
                            }
                        }
                    }

                    if (hasOne) {
                        break;
                    }
                }

                return hasOne;
            }
        });
    }
}


// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/pipes/filter.pipe.ts